import { type RouteObject } from 'react-router-dom';

import { InterviewRootLayout } from './InterviewRootLayout';

export const interviewRoutes: RouteObject = {
  path: 'interview',
  children: [
    {
      element: <InterviewRootLayout />,
      children: [
        {
          path: 'logout',
          lazy: () => import('../../app/logout/page'),
        },
        {
          path: 'hardware-control',
          lazy: () => import('../../app/interview/hardware-control/page'),
        },
        {
          path: 'questions',
          lazy: () => import('../../app/interview/questions/page'),
        },
        {
          path: 'sample-question',
          lazy: () => import('../../app/interview/sample-question/page'),
        },
        {
          path: 'start',
          lazy: () => import('../../app/interview/start/page'),
        },
        {
          path: 'submit',
          lazy: () => import('../../app/interview/submit/page'),
        },
        {
          path: 'suggestions',
          lazy: () => import('../../app/interview/suggestions/page'),
        },
      ],
    },
    {
      path: ':interviewId/company/:companyId/link',
      lazy: () => import('../../app/interview/link/page'),
    },
  ],
};
